import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import type { Genie2ReportingMode } from '~/utils/analyticsReportingMode';
import {
  getColumnAccessGoLiveWarning,
  type ColumnAccessGoLiveWarningOptions,
} from './columnAccessApplyConfirmUtils';

export function ColumnAccessGoLiveWarning({
  mode,
  audience = 'staff',
  currentMode = null,
}: {
  mode: Genie2ReportingMode;
} & ColumnAccessGoLiveWarningOptions) {
  const { lead, detail } = getColumnAccessGoLiveWarning(mode, { audience, currentMode });

  return (
    <Alert severity="error" variant="outlined">
      <Typography variant="body2" fontWeight={700} component="div" sx={{ mb: 0.5 }}>
        {lead}
      </Typography>
      <Typography variant="body2" component="div">
        {detail}
      </Typography>
    </Alert>
  );
}

type ColumnAccessDiffSectionProps = {
  title: string;
  labels: readonly string[];
};

/** Scrollable two-column label list for the go-live apply confirm dialog. */
export function ColumnAccessDiffSection({ title, labels }: ColumnAccessDiffSectionProps) {
  const count = labels.length;

  return (
    <Box>
      <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
        {title} ({count})
      </Typography>
      {count === 0 ? (
        <Typography variant="body2" color="text.secondary">
          None
        </Typography>
      ) : (
        <Box
          sx={{
            maxHeight: 240,
            overflowY: 'auto',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'grey.50',
            px: 1.5,
            py: 1,
          }}
        >
          <Box
            component="ul"
            sx={{
              m: 0,
              p: 0,
              listStyle: 'none',
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              columnGap: 2,
              rowGap: 0.5,
            }}
          >
            {labels.map((label) => (
              <Typography
                key={label}
                component="li"
                variant="body2"
                sx={{ lineHeight: 1.4, wordBreak: 'break-word' }}
              >
                {label}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
